export default __webpack_public_path__ + "static/media/Entira Logo-Green-for Web.89084c7d.jpg";